<div class="p-l-2-m p-r-2-m"
     [class.ng-hide]="!display"
     [id]="'checkout-step-' + name">
    <div class="w-12">
        <ng-content />
    </div>
</div>